// PUBLIC ROURES
const LOGIN = "/login";
const SIGNUP = "/signup";
const FORGOT_PASSWORD = "/forgot-password";
const INACTIVE_ACCOUNT = "/inactive-account";

// PROTECTED
const RESET_PASSWORD = "/reset-password";

// ADMIN ROUTES
const HOME = "/";
const SALESDATA = "/sales-data";
const TRACKS = "/tracks";
const LABELS = "/labels";
const ARTISTS = "/artists";
const LYRICISTS = "/lyricists";
const COMPOSERS = "/composers";
const DISTRIBUTOR = "/distributors";
const PLATFORM = "/platforms";
const CLIENTS = "/clients";
const PAYMENTS = "/payments";
const INVOICES = "/invoices";
const INCOME = "/income";
const USERS = "/users";
const SIGNUP_REQUESTS = "/signup-requests";
const SETTINGS = "/settings";

const CLIENT_DETAILS_ID = `${CLIENTS}/:clientId`;
const PAYMENT_DETAILS_ID = `${PAYMENTS}/:paymentId`;
const INVOICE_DETAILS_ID = `${INVOICES}/:invoiceId`;

const ROUTES = {
  PATHS: {
    LOGIN,
    SIGNUP,
    FORGOT_PASSWORD,
    RESET_PASSWORD,
    INACTIVE_ACCOUNT,
    ADMIN: {
      HOME,
      SALESDATA,
      TRACKS,
      LABELS,
      ARTISTS,
      LYRICISTS,
      COMPOSERS,
      DISTRIBUTOR,
      PLATFORM,
      CLIENTS,
      PAYMENTS,
      INVOICES,
      INCOME,
      USERS,
      SIGNUP_REQUESTS,
      SETTINGS,
      CLIENT_DETAILS_ID,
      PAYMENT_DETAILS_ID,
      INVOICE_DETAILS_ID,
    },
  },
  CLIENT_DETAILS_ID: (clientId: string) =>
    CLIENTS.replace(":clientId", clientId),
  PAYMENT_DETAILS_ID: (paymentId: string) =>
    PAYMENTS.replace(":paymentId", paymentId),
  INVOICE_DETAILS_ID: (invoiceId: string) =>
    PAYMENTS.replace(":invoiceId", invoiceId),
};

export default ROUTES;
